<template>
  <div>
    <general-textarea
      dense
      v-model="$data.$_note"
      v-bind:rows="$_numRowsOfNote"
      v-bind:messages="$data.$_message"
      v-on:blur="$_saveNote"
    >
    </general-textarea>
    <div class="timeline-segment-editor-note-button-container">
      <v-spacer></v-spacer>
      <v-btn
        outlined text x-small
        v-on:click="$_deleteNote"
      >
        <span>Delete Note</span>
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
div.timeline-segment-editor-note-button-container {
  display: flex;
  align-items: center;
}
</style>

<script>
import { TimelineSegmentId } from '../../../modules/ScattData.js';
import GeneralTextarea from '../../Parts/Inputs/GeneralTextarea.vue';
import utils from '../../../modules/utils.js';

const displayMessageDurationMsec = 2000;

export default {
  components: {
    GeneralTextarea,
  },

  watch: {
    note: {
      handler() { this.$_loadNote(); },
      immediate: true,
    },
  },

  props: {
    noteTimelineSegmentId: { type: TimelineSegmentId },
    note:                  { type: String },
  },

  data() {
    return {
      $_note: undefined,
      $_message: undefined,
    };
  },

  computed: {
    $_numRowsOfNote() { return utils.countNumLines(this.$data.$_note); },
  },

  inject: [
    'deleteSegments',
  ],

  methods: {
    $_loadNote() {
      this.$data.$_note = String(this.note);
    },

    $_saveNote() {
      this.$emit('save-note', this.noteTimelineSegmentId, this.$data.$_note);
      this.$data.$_message = 'autosaved';
      window.setTimeout(
        () => { this.$data.$_message = undefined; },
        displayMessageDurationMsec,
      );
    },

    $_deleteNote() {
      this.deleteSegments([ this.noteTimelineSegmentId ]);
    },
  },
}
</script>